import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, useTheme } from './themes/ThemeContext';
import { themes } from './themes';
import { About } from './pages/About';
import { ResidentStory } from './pages/ResidentStory';
import './style.css';

function AppContent() {
  const { theme } = useTheme();
  const themeConfig = themes[theme];

  const Header = themeConfig.Header;
  const Footer = themeConfig.Footer;

  return (
    <themeConfig.Layout Header={<Header />} Footer={<Footer />}>
      <Routes>
        <Route path="/" element={<themeConfig.Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/resident/:id" element={<ResidentStory />} />
      </Routes>
    </themeConfig.Layout>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </BrowserRouter>
  );
}
